import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { useQuery } from '@apollo/react-hooks';
import { useTranslation } from 'react-i18next';

import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormHelperText from '@material-ui/core/FormHelperText';

import CloseIcon from '@material-ui/icons/Close';

import { useStyles, autocompleteStyles, chipStyles } from './styles';

const AsyncChipsInput = ({
  input,
  label,
  placeholder,
  maxLength,
  className,
  query,
  queryName,
  optionLabel,
  remove,
  businessOwner,
  meta: { touched, error }
}) => {
  const classes = useStyles();
  const autocompleteClasses = autocompleteStyles();
  const chipClasses = chipStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);

  const { loading, data, refetch } = useQuery(query, {
    variables: {
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    }
  });

  React.useEffect(() => {
    if (!loading) setOptions(data[queryName] || []);
  }, [data]);

  React.useEffect(() => {
    refetch();
  }, []);

  const getOption = option => {
    return selectedLanguage === 'Norway' && option[`${optionLabel}No`]
      ? option[`${optionLabel}No`]
      : option[optionLabel];
  };

  return (
    <div className={classNames(classes.root, className)}>
      <InputLabel className={classes.label} htmlFor={`${label}-input`}>
        {t(label)}
      </InputLabel>

      <Autocomplete
        multiple
        id="asynchronous-demo"
        className={classNames({
          [classes.error]: touched && error
        })}
        classes={autocompleteClasses}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onChange={(event, value) => {
          const deletedItems = input.value.filter(x => !value.includes(x));
          if (deletedItems.length) remove(deletedItems[0]);
          input.onChange(value);
        }}
        value={input.value}
        getOptionSelected={(option, value) => `${option.id}` === `${value.id}`}
        getOptionLabel={option => getOption(option)}
        options={options}
        loading={loading}
        closeIcon={<div className={classes.closeIcon}>{''}</div>}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              classes={chipClasses}
              variant="outlined"
              label={getOption(option)}
              deleteIcon={<CloseIcon className={classes.deleteChipIcon} />}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={params => (
          <TextField
            {...params}
            variant="filled"
            placeholder={t(placeholder)}
            fullWidth
            inputProps={{
              ...params.inputProps,
              maxLength: maxLength
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              )
            }}
          />
        )}
      />

      {touched && error && <FormHelperText error>{error}</FormHelperText>}
    </div>
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(AsyncChipsInput);
